"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User(data) {
        var _this = _super.call(this, data) || this;
        _this.username = data.username;
        _this.email = data.email;
        _this.phone = data.phone;
        _this.formattedPhone = data.formatted_phone;
        _this.name = data.name;
        _this.address = data.address;
        _this.personalDiscount = data.personal_discount;
        _this.legalType = data.legal_type;
        _this.legalTypeLabel = data.legal_type_label;
        _this.organizationName = data.organization_name;
        _this.inn = data.inn;
        _this.accountDetails = data.account_details;
        _this.sex = data.sex;
        _this.sexLabel = data.set_label;
        _this.birthday = data.birthday;
        _this.activeBonuses = data.active_bonuses;
        _this.totalBonuses = data.total_bonuses;
        _this.avatarId = data.avatar_image_id;
        _this.bonusCard = data.bonus_card;
        _this.bonusPercent = data.bonus_percent;
        _this.isTwoFactorEnabled = data.is_two_factor_enabled;
        _this.group = data.group ? {
            id: data.group.id,
            name: data.group.name
        } : undefined;
        _this.externalData = data.external_data;
        var dynamicFields = __assign({}, data);
        [
            'username', 'email', 'phone', 'formatted_phone', 'name', 'address', 'personal_discount', 'legal_type',
            'legal_type_label', 'organization_name', 'inn', 'account_details', 'sex', 'set_label', 'birthday', 'active_bonuses',
            'total_bonuses', 'avatar_image_id', 'bonus_card', 'bonus_percent', 'is_two_factor_enabled', 'external_data'
        ].map(function (key) {
            delete dynamicFields[key];
        });
        _this.dynamicFields = dynamicFields;
        return _this;
    }
    return User;
}(BaseEntity_1.BaseEntity));
exports.User = User;
//# sourceMappingURL=User.js.map